import { useCallback, useEffect, useRef, useState } from "react";
import { useAccount } from "./AccountContext";

export const OTHER_EMAIL_NOTE = "Заказ на другую почту не появится в кабинете";
export const CONSENT_AGAIN_NOTE =
  "Вход в кабинет истёк. Отметьте согласие на обработку персональных данных и оплатите снова.";

/**
 * Почта для формы заказа: подставляется из кабинета, пока покупатель не правил поле.
 * coveredByAccount — заказ на почту кабинета: согласие дано при создании кабинета,
 * галочка в форме не нужна (сервер проверяет это по сессии сам).
 */
export function useAccountEmail() {
  const { account, refresh } = useAccount();
  const accountEmail = account?.email || "";
  const [email, setEmailState] = useState("");
  const touchedRef = useRef(false);

  useEffect(() => {
    if (accountEmail && !touchedRef.current) {
      setEmailState(accountEmail);
    }
  }, [accountEmail]);

  const setEmail = useCallback((value) => {
    touchedRef.current = true;
    setEmailState(value);
  }, []);

  const trimmed = email.trim().toLowerCase();
  const signedIn = Boolean(accountEmail);
  const differsFromAccount = signedIn && trimmed !== "" && trimmed !== accountEmail;
  const coveredByAccount = signedIn && trimmed === accountEmail;

  return { email, setEmail, differsFromAccount, signedIn, coveredByAccount, refreshAccount: refresh };
}
